import React, {useState, useEffect, useRef, useContext } from 'react';
import {LayoutContext} from '_context/LayoutContext';
import { MapContext } from '_context/MapContext';
import AsyncSelect from 'react-select/async';
import { getItem } from '_services/agent';
import { Pagination } from 'component/Pagination';
import { Loading } from 'component/Loading';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { PlaceList } from 'component/PlaceList';
import {ollehModule} from '../common/mapAPIExport'

const RPNearSearch = (props) => {
    const {status, chgStatus} = useContext(LayoutContext)
    const [search, setSearch] = useState("");
    const [point, setPoint] = useState({})
    const [value, setValue] = useState("")
    const [poiData, setPoiData] = useState([]);
    const selectRef = useRef()
    const [pages, setPages] = useState({
        pageCount : null,
        pageIndex : 0,
        pageTotal : 0,
        sort : "relevance"
    })
    const [loading, setLoading] = useState(false);
    const poiRef = useRef();
    const { nearPoi, setNearPoi, selectedId, routes, rpOpts, rp } = useContext(MapContext);
    let tmpH = window.document.body.offsetHeight-310;

    useEffect(() => {
        if(search) {
            setPageIndex(0,true);
        }else{
            setNearPoi(null)
            setValue('')
        }
    }, [search]);

    useEffect(() => {
        setPageIndex(0,true);
    }, [routes, rpOpts]);

    useEffect(() => {
        setNearPoi(null)
        setValue('')
        setSearch('')
    }, [rp]); //경로가 변경면 clear한다

    useEffect(() => {
        if(poiRef.current===undefined){return }
        if(selectedId){
            var elem = document.getElementById("list-"+selectedId);
            if(poiRef.current){
                let poiInstance =  poiRef.current.osInstance();
                if(poiInstance && elem){
                    poiInstance.scroll(elem,500);
                }
            }
        }
    },[selectedId]);

    const selStyles = {
        option: (styles, state) => ({...styles, color: state.isSelected ? "#333" : '#777', "&:hover": {color: "#333", backgroundColor: "#eee"},}),
        control: (base, state) => ({...base, boxShadow: state.isFocused ? 0 : 0, border:'1px solid #ccc', width:'330px'}),
        menuList: (provided, state) => ({...provided,minHeight:'424px',})
    };

    const loadOptions = (inputValue, callback) => {
        getItem('autocomplete','',{
          point: {lat: 37.570026282477116, lng: 126.97714803962387},
          terms: inputValue
        }).then(res => {
            let serverData = res.data.suggests;
            const opts = serverData.map((item) => ({value:item.terms,label:item.terms}));
            callback(opts);
        }).catch(err => {});
    };

    const onKeyDown = event => {
        if (event.keyCode === 13) {
            event.stopPropagation();
            event.preventDefault();
            selectRef.current.setState({menuIsOpen: false})
            selectRef.current.blur()
            setSearch(value)
        }
    };

    const onChange = (e, { action }) => {
        if(action==="select-option"){
            setSearch(e.label)
        }else if(action==="clear"){
            setSearch('')
        }
    }

    const onPageChange = (name,value) => {
        setPages({
          ...pages, 
          [name]: value 
        });
      };
  
    const handleSearchInput = (e, { action }) => {
        if (action === "menu-close" || action === "input-blur" || action === "set-value") {
            return;
        } else {
            setValue(e)
        }
    };

    const setPageIndex = (idx,mode) => {
        onPageChange("pageIndex",idx)
        if(mode){fetchData(idx);}
    }

    async function fetchData(pageIndex){
        if(!search) return
        setLoading(true);
        let routeInfo = {points:getLatLngPath(), distance: 500}
        await getItem('poi','?sortBy='+pages.sort+'&mode=NAVIGATION&numberOfResults=50&start='+(pageIndex*50),{
           point: {lat: 37.570026282477116, lng: 126.97714803962387},
           terms: search,
           route: routeInfo
         }).then(res => {
             setLoading(false);
             if(res.data.numberOfPois && res.data.numberOfPois>20000){
                res.data.numberOfPois = 20000
             }
             serverDataDispose(res.data)
         }).catch(err => {
            setLoading(false);
        });
    };

    const getLatLngPath =  ()=> {
        let route = routes.filter((route) => {if(route.rpType===rpOpts.rpType) return route;})[0]
        let LatLngPath = []
        if(route && route['polyline']){
            route['polyline'].getPath()._coords.some((point) => {
                let latlng = new ollehModule.maps.LatLng.valueOf(point);
                LatLngPath.push({lat: latlng.y, lng: latlng.x});
            });
        }
        return LatLngPath;
    }

    const serverDataDispose = (serverData)=>{
        setPoiData(serverData.pois);
        setPages({
            ...pages,
            pageCount: Math.ceil(serverData.numberOfPois / 50),
            pageTotal: serverData.numberOfPois,
            addrTotal : serverData.numberOfAddress
        })
        setNearPoi(serverData);
        if(poiRef.current){
            let poiInstance =  poiRef.current.osInstance();
            if(poiInstance){
                poiInstance.scrollStop().scroll({
                    x: 0,
                    y: 0
                });
            }
        }
    }

    return (
        <div className="lyDimInner" id="lypopRouteSearch" style={{display:status==='routeNear'?'block':'none'}}>
			<div className="lyBox routeSearch">
				<div className="title">경로 내 장소검색</div>
				<div className="innerSearch">
                    <AsyncSelect 
                        ref={selectRef}
                        loadOptions={loadOptions}
                        className="selSearch-container"
                        classNamePrefix="selSearch"
                        styles={selStyles}
                        components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                        value={value?{"value":value,"label":value,"point":point}:null}
                        inputValue={value}
                        onKeyDown={onKeyDown}
                        onChange={(e,action)=>onChange(e,action)}
                        onInputChange={(e,action)=>handleSearchInput(e,action)}
                        noOptionsMessage={() => null}
                        isClearable
                        placeholder={'검색어를 입력하세요'}/>
				</div>
                <div className="plugin-scrollbar-bd" style={{display:search===''?'none':'block'}}>
                    <div className="plugin-scrollbar os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-scrollbar-vertical-hidden os-host-transition">
                    <OverlayScrollbarsComponent ref={poiRef} style={{ maxHeight: tmpH }}>
                    { loading ?<Loading />:
                        <div className="list">
                        <ul>
                        {poiData.map((row,i)=><PlaceList mode="rp" poiSeqLabelType={true} key={i} idx={i} obj={row} isActive={selectedId===row.id?true:false} />)}               
                        </ul></div>
                    }
                    </OverlayScrollbarsComponent> 
                    </div>
                </div>
                <div className="wrapBot" style={{display:search===''?'none':'block'}}>
                    <Pagination pageCount={pages.pageCount} onChange={setPageIndex} />
                </div>
				<button className="btnsSch btnClose" onClick={()=>chgStatus("rp")}>닫기</button>
			</div>
		</div>
    )
}

export default RPNearSearch